import React from 'react';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import DropDownCountry from 'components/IncorporationOfTerms/Register/FormAtoms/DropDownCountry';

export const ResidenceCntry = () => {
  return (
    <TblRow>
      <TblRowHeader rowHeader="MB_T_COUNTRY_RESIDENCE" isRequired />
      <TblRowTail unUsedInputBox>
        <DropDownCountry />
      </TblRowTail>
    </TblRow>
  );
};

export default ResidenceCntry;
